export type Row = {
  display_id: string
}

function isEmpty(obj: Row[]) {
  return !Object.keys(obj).length;
}

export const convertSelectedDates = (rows: Row[]): Date[] => {
  if (isEmpty(rows)) {
    rows = [];
  }
  return rows.map((row: Row) => {
    return new Date(row.display_id)
  })
}
